<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div style="background-color: white">
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <date-picker
                            v-model="search.date"
                            type="date"
                            range
                            :format="changeFormat"
                            :lang="lang"
                            confirm
                            placeholder="วันที่ขึ้นเงิน">
                        </date-picker>
                        &nbsp;
                        <button type="button" class="btn btn-info" @click="onSearch">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                        &nbsp;
                        <!--                        <button type="button" class="btn btn-warning" @click="createStatementCash">-->
                        <!--                            <icon name="plus"></icon>-->
                        <!--                            เงินสด-->
                        <!--                        </button>-->
                        <!--                        &nbsp;-->
                        <!--                        <button type="button" class="btn btn-primary"-->
                        <!--                                @click="printStatement(loading_data.url)"-->
                        <!--                                v-if="loading_data.url">-->
                        <!--                            <icon name="print"></icon>-->
                        <!--                            พิมพ์ Statement-->
                        <!--                        </button>-->
                        <!--                        <button type="button" class="btn btn-danger"-->
                        <!--                                disabled-->
                        <!--                                v-else>-->
                        <!--                            <icon name="print"></icon>-->
                        <!--                            Loading...-->
                        <!--                        </button>-->
                    </form>
                </div>
            </nav>
            <div class="row ml-1">
                <span style="padding-right: 10px"><b>ชื่อบัญชี :</b>
                        <template v-if="statement.bank">
                            {{ statement.bank.account_name }}
                        </template>
                    </span>
                <span style="padding-right: 10px"><b>เลขที่บัญชี :</b>
                        <template v-if="statement.bank">
                            {{ statement.bank.account_number }}
                        </template>
                    </span>
                <span style="padding-right: 10px"><b>สาขา :</b>
                        <template v-if="statement.bank">
                            {{ statement.bank.bank_branch }}
                        </template>
                </span>
                <label style="color: red">*ดึงข้อมูลเริ่มต้น ต้นเดือน - ปัจจุบัน*({{ first_day | moment('DD/MM/YYYY') }}
                    - {{ current_day | moment('DD/MM/YYYY') }})</label>
            </div>
            <!--            <div class="ml-2">-->
            <!--                <label style="text-align: right">ยอดเงินรวมของบัญชี :-->
            <!--                    <span style="font-weight: bold ; " v-if="loading_data.sum">{{parseFloat(loading_data.sum)| currency}}</span>-->
            <!--                    <span style="font-weight: bold ;color: red " v-else>loading...</span> บาท-->
            <!--                    <template v-if="search.date.length > 0">-->
            <!--                        <span style="font-weight: bold ; ">ยอดเงินของวันที่-->
            <!--                            ({{search.date[0]  | moment('DD/MM/YYYY')}}- -->
            <!--                            {{search.date[1] | moment('DD/MM/YYYY')}})-->
            <!--                            คือ {{parseFloat(statement.sum_debit) - parseFloat(statement.sum_credit)| currency}}</span>-->
            <!--                        บาท-->
            <!--                    </template>-->
            <!--                </label>-->
            <!--            </div>-->
            <div class="ml-2" v-if="search.date.length > 0">
                <div class="row">
                    <div class="col-6">
                        <label style="text-align: right">ยอดรวมเครดิต :
                            {{ sumCredit | currency }}
                        </label>
                    </div>
                    <div class="col-6">
                        <label style="text-align: right">ยอดรวมเดบิต :
                            {{ sumDebit | currency }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="table table-responsive" style="min-height: 250px">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>ลำดับ</th>
                        <th>เดือน</th>
                        <th>ปี</th>
                        <th>เครดิต</th>
                        <th>เดบิต</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(info, index) in statement">
                        <tr>
                            <td>{{ index + 1 }}</td>
                            <td>{{ info.month_year.substring(0, 2) }}</td>
                            <td>{{ info.month_year.substring(2, 6) }}</td>
                            <td>
                                <template v-if="info.sum_credit">
                                    {{ info.sum_credit | currency }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                <template v-if="info.sum_debit">
                                    {{ info.sum_debit | currency }}
                                </template>
                                <template v-else>-</template>
                            </td>
                        </tr>
                    </template>
                    <tr style="font-weight: bold">
                        <td colspan="3" style="text-align: right ;">รวม</td>
                        <td>
                            {{ sumCredit | currency }}
                        </td>
                        <td>
                            {{ sumDebit | currency }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!--add data-->
            <b-modal hide-footer hide-header ref="statement_cash">
                <statement-modal
                    :form="form"
                    @submit="saveStatement">
                </statement-modal>
            </b-modal>
            <!--delete data-->
            <b-modal hide-footer hide-header ref="delete_item">
                <delete-confirm-modal @submit="deleteStatement">
                </delete-confirm-modal>
            </b-modal>
            <b-modal hide-header hide-footer ref="loading">
                <loading :msg="msg" :status="status_loading" @submit="hideLoading"></loading>
            </b-modal>
        </div>
        <!--<pre class="alert-primary">{{first_day}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import StatementModal from "./StatementModal";
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
import Loading from "../../Utility/Loading";

export default {
    name: "statement-data",
    components: {
        Loading,
        DeleteConfirmModal,
        StatementModal,
        DatePicker
    },
    created() {
        this.getFirstDayOfMonth();
    },
    data() {
        return {
            msg: '',
            status_loading: '',
            loading_data: {
                url: '',
                sum: ''
            },
            search: {
                date: []
            },
            items: [
                {
                    text: "รายการเดบิต - เครดิต",
                    to: {name: "statement-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            first_day: '',
            current_day: '',
            statement_id: null,
            form: {
                bank_id: '',
                date: "",
                customer_id: "",
                customer: [],
                debit: "",
                credit: null,
                transaction_type_id: 3,
                transaction_type: "",
            },
            date_week: [],
        }
    },
    computed: {
        ...mapState({
            statement: state => {
                return state.Bank.statement_month_data;
            }
        }),
        sumCredit() {
            return this.statement.reduce((carry, detail) => {
                let credit = 0;
                if (detail.sum_credit) {
                    credit = detail.sum_credit
                }
                return carry + parseFloat(credit)
            }, 0);
        },
        sumDebit() {
            return this.statement.reduce((carry, detail) => {
                let debit = 0;
                if (detail.sum_debit) {
                    debit = detail.sum_debit
                }
                return carry + parseFloat(debit)
            }, 0);
        },

    },
    methods: {
        showLoading() {
            this.$refs.loading.show();
        },
        hideLoading() {
            this.$refs.loading.hide();
        },
        showStateCash() {
            this.$refs.statement_cash.show();
        },
        hideStateCash() {
            this.$refs.statement_cash.hide();
        },
        showDeleteCash(id) {
            this.statement_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteCash() {
            this.$refs.delete_item.hide();
        },
        validateDateRange() {
            let dates = [];
            if (this.search.date.length > 0) {
                let currentDate = moment(this.search.date[0]);
                let end_date = moment(this.search.date[1]);
                while (currentDate <= end_date) {
                    dates.push(moment(currentDate).format("YYYY-MM-DD"));
                    currentDate = moment(currentDate).add(1, 'days')
                }
                this.date_week = dates;
            }
            //console.log(this.date_week.length);
        },
        saveStatement(submit) {
            if (submit) {
                if (this.statement_id) {
                    //console.log(this.statement_id);
                    this.$store.dispatch("Bank/editStatement", {
                        id: this.statement_id,
                        data: submit
                    }).then(() => {
                        this.onSearch(); //get statement
                    });
                } else {
                    submit.bank_id = this.statement.bank.id;
                    //console.log(submit);
                    this.$store.dispatch("Bank/saveStatement", submit).then(() => {
                        this.onSearch(); //get statement
                    });
                }
            }
            this.hideStateCash();
        },
        onSearch() {
            this.loading_data.url = '';
            this.loading_data.sum = '';
            let bank_id = this.statement.bank.id;
            // let bank_id = 7;
            let start_date = "";
            let end_date = "";
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.date = [];
            }
            this.validateDateRange();
            // if(this.date_week.length > 100){
            //     alert('เลือกได้ไม่เกิน 100 วัน เนื่องจากข้อมูลมีจำนวนมาก');
            // }else{
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoading();
            this.$store.dispatch("Bank/getStatementMonth", {
                bank_id: bank_id,
                start_date: start_date,
                end_date: end_date
            }).then(() => {
                this.msg = 'ดาวโหลดข้อมูลสำเร็จ';
                this.hideLoading();
                //console.log(this.statement)
                // this.$store.dispatch("Bank/getSumStatement", {
                //     bank_id: bank_id,
                //     start_date: start_date,
                //     end_date: end_date
                // }).then(res=>{
                //     this.loading_data.url = res.file_url;
                //     this.loading_data.sum = res.sum_statement;
                // })
            }).catch(err => {
                this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ';
                this.status_loading = 3;
            })
            // }
        },
        goToStatementList() {
            this.$router.push("/account/statement");
        },
        getFirstDayOfMonth() {
            let date = new Date();
            this.first_day = new Date(date.getFullYear(), date.getMonth(), 1);
            this.current_day = new Date();
        },
        createStatementCash() {
            this.statement_id = null;
            this.form = {
                bank_id: '',
                date: '',
                customer_id: "",
                customer: [],
                debit: '',
                credit: null,
                transaction_type_id: 3,
                transaction_type: "",
            };
            this.showStateCash();
        },
        showStatement(id) {
            this.statement_id = id;
            this.$store.dispatch("Bank/showStatement", id).then(res => {
                this.form = {
                    bank_id: res.bank_id,
                    date: res.date,
                    customer_id: "",
                    customer: [],
                    debit: res.debit,
                    credit: res.credit,
                    transaction_type_id: 3,
                    transaction_type: "",
                };
                this.showStateCash();
            })
        },
        deleteStatement(submit) {
            if (submit) {
                this.$store.dispatch("Bank/deleteStatement", this.statement_id).then(() => {
                    alert('ลบรายการสำเร็จ');
                    this.onSearch();
                }).catch(err => {
                    alert('ลบรายการไม่สำเร็จ');
                })
            }
            this.hideDeleteCash();
        },
        printStatement(url) {
            if (url) {
                window.open(url, '_blank');
            }
        },
    }
}
</script>

<style scoped>
thead {
    background-color: darkgrey;
    color: black;
}

tbody {
    background-color: white;
    color: black;
}
</style>
